import React from 'react'
import { Grid, TextField } from '@mui/material'
import Paragraph from '../../shared/UI/Paragraph'
import { RequestDetailResponse } from '../../types/requests'
import { formatDateWithLocale } from '../../utils/date-utils'
import NoDataFound from '../../shared/UI/NoDataFound'
import LoadingIndicator from '../../shared/UI/LoadingIndicator'
import { globalContent } from '../../utils/constants'

interface RequestDetailsCardProps {
  requestDetail: RequestDetailResponse | null
  isLoading: boolean
  hasBothDates: boolean
}

function RequestDetailsCard({ requestDetail, isLoading, hasBothDates }: RequestDetailsCardProps) {
  const formattedDateFrom = requestDetail && formatDateWithLocale(requestDetail.dateFrom)
  const formattedDateTo = requestDetail && formatDateWithLocale(requestDetail.dateTo)
  const formattedDateSubmitted = requestDetail && formatDateWithLocale(requestDetail.dateSubmitted)

    return (
      <>
        {requestDetail ? (
          <Grid container spacing={4}>
            <Grid container item xs={12} spacing={1}>
              <Grid container item columns={14} columnSpacing={1}>
                <Grid item xs={4}>
                  <Paragraph weight="bold">{globalContent.dateFrom}</Paragraph>
                </Grid>
                <Grid item xs={4}>
                  <Paragraph>{formattedDateFrom}</Paragraph>
                </Grid>
                {hasBothDates && (
                  <>
                    <Grid item xs={3}>
                      <Paragraph weight="bold">{globalContent.dateTo}</Paragraph>
                    </Grid>
                    <Grid item xs={3}>
                      <Paragraph>{formattedDateTo}</Paragraph>
                    </Grid>
                  </>
                )}
              </Grid>
              <Grid container item columns={14} columnSpacing={1}>
                <Grid item xs={4}>
                  <Paragraph weight="bold">{globalContent.dateSubmitted}</Paragraph>
                </Grid>
                <Grid item xs={4}>
                  <Paragraph>{formattedDateSubmitted}</Paragraph>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Requester comments"
                fullWidth
                multiline
                rows={4}
                disabled
                defaultValue={requestDetail.requesterComments}
              />
            </Grid>
          </Grid>
        ) : (
          <>
            <NoDataFound show={!isLoading && !requestDetail} />
            <LoadingIndicator show={isLoading} />
          </>
        )}
      </>
    )
}

export default RequestDetailsCard